export enum BuddyMessageFeedbackFlag {
    WRONG = 'WRONG',
    HARMFUL = 'HARMFUL',
    OFFENSIVE = 'OFFENSIVE',
    REPETITION = 'REPETITION',
    UNCLEAR = 'UNCLEAR',
    INSUFFICIENT = 'INSUFFICIENT',
    OTHER = 'OTHER',
}
